/**
 * Форматирование дат для UI ИИ-Колхоза.
 * Стандарт: «ДД мес. ГГГГ», например "28 сен. 2020".
 */
const MONTHS_RU_SHORT = [
  'янв.',
  'фев.',
  'мар.',
  'апр.',
  'май',
  'июн.',
  'июл.',
  'авг.',
  'сен.',
  'окт.',
  'ноя.',
  'дек.',
];

function parseInput(input?: string | Date | null): Date | null {
  if (!input) return null;
  if (input instanceof Date) return isNaN(input.getTime()) ? null : input;
  if (typeof input !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(input);
  const d = m
    ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    : new Date(input);
  return isNaN(d.getTime()) ? null : d;
}

export function formatRuDate(input?: string | Date | null): string {
  const d = parseInput(input);
  if (!d) return '';
  const day = d.getDate();
  const mo = MONTHS_RU_SHORT[d.getMonth()] ?? '';
  const y = d.getFullYear();
  return `${day} ${mo} ${y}`;
}

export function formatRuDateNumeric(input?: string | Date | null): string {
  const d = parseInput(input);
  if (!d) return '';
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${dd}.${mm}.${d.getFullYear()}`;
}

/** «1 хозяйство / 2 хозяйства / 5 хозяйств» — общий склонятель числительных. */
export function pluralRu(n: number, forms: readonly [string, string, string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return forms[0];
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1];
  return forms[2];
}

/**
 * «5 минут назад» / «3 часа назад» / «2 дня назад» — для статус-бордов
 * (AK-738), где важна свежесть, а не точная дата. Старше 30 дней —
 * откатывается на абсолютную дату (`formatRuDate`), относительное «N дней
 * назад» на таком масштабе только мешает читать.
 */
export function formatRelativeRu(input?: string | Date | null, now: Date = new Date()): string {
  if (!input) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';
  const diffMin = Math.round((now.getTime() - d.getTime()) / 60000);
  if (diffMin < 1) return 'только что';
  if (diffMin < 60) return `${diffMin} ${pluralRu(diffMin, ['минуту', 'минуты', 'минут'])} назад`;
  const diffH = Math.round(diffMin / 60);
  if (diffH < 24) return `${diffH} ${pluralRu(diffH, ['час', 'часа', 'часов'])} назад`;
  const diffD = Math.round(diffH / 24);
  if (diffD < 30) return `${diffD} ${pluralRu(diffD, ['день', 'дня', 'дней'])} назад`;
  return formatRuDate(d);
}
